import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { MarketingFooter } from "./MarketingFooter";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [location] = useLocation();

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/sign-in", label: "Sign in" },
    { href: "/apply", label: "Apply for Early Access" },
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 flex flex-col">
      <header className="sticky top-0 z-50 bg-slate-950/90 backdrop-blur-sm border-b border-slate-800">
        <nav className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
          <Link href="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <img src="/logo-40.png" alt="The Lifecycle Canvas" className="w-10 h-10" />
            <span className="text-xl font-display font-bold text-white group-hover:text-teal-400 transition-colors">
              The Lifecycle Canvas
            </span>
          </Link>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:gap-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={cn(
                  "text-sm font-medium transition-colors",
                  location === link.href
                    ? "text-teal-400"
                    : "text-slate-400 hover:text-white",
                  link.href === "/apply" && "px-4 py-2 bg-teal-700 hover:bg-teal-600 text-white rounded-lg"
                )}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="/legal"
              className={cn(
                "text-sm font-medium transition-colors",
                location === "/legal" ? "text-teal-400" : "text-slate-400 hover:text-white"
              )}
              data-testid="nav-legal"
            >
              Legal
            </Link>
          </div>
        </nav>
      </header>

      <main className="flex-1">
        {children}
      </main>

      <MarketingFooter />
    </div>
  );
}
